"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleServerError = exports.hideGlobalMessage = exports.hideGlobalMessageComponent = exports.showGlobalMessage = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'SERVICES';
var showGlobalMessage = (0, _reduxAct.createAction)("".concat(PREFIX, "/SHOW_GLOBAL_MESSAGE"));
exports.showGlobalMessage = showGlobalMessage;
var hideGlobalMessageComponent = (0, _reduxAct.createAction)("".concat(PREFIX, "/HIDE_GLOBAL_MESSAGE_COMPONENT"));
exports.hideGlobalMessageComponent = hideGlobalMessageComponent;
var hideGlobalMessage = (0, _reduxAct.createAction)("".concat(PREFIX, "/HIDE_GLOBAL_MESSAGE"));
exports.hideGlobalMessage = hideGlobalMessage;
var handleServerError = (0, _reduxAct.createAction)("".concat(PREFIX, "/HANDLE_SERVER_ERROR"));
exports.handleServerError = handleServerError;